
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CasesHero from './components/CasesHero';
import ResearchDirections from './components/ResearchDirections';

const CasesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <CasesHero />
        <ResearchDirections />
      </main>
      <Footer />
    </div>
  );
};

export default CasesPage;
